import { Button } from '@material-ui/core';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import './Blogs.css';

const Blogs = () => {
    return (
        <section className='blogs' id='blogs'>
            <h1 className="title" data-aos="zoom-in">Blogs</h1>
            <div className="blog_container">
                <div className="timeline">
                    <ul>
                        <li>
                            <div className="timeline_content">
                                <h1 className='blog_date text-sm'>12 July, 2021</h1>
                                <h1 className='text-2xl mb-3'>JavaScript Array Methods</h1>
                                <p className='font-thin'>In this blog, I gonna show you the most Important 20 Array methods. As a JavaScript developer, These methods, you must know.</p>
                                <small>5 min read...</small><br />
                                <a target='_blank' rel="noreferrer" href="https://mdtajuuddintarek.medium.com/most-important-javascript-array-methods-1e591ccf3c86"><Tooltip TransitionComponent={Zoom} title="To Medium.com" placement="top" arrow><Button className='blogs_btn'>View</Button></Tooltip></a>
                            </div>
                        </li>
                        <li>
                            <div className="timeline_content">
                                <h1 className='blog_date text-sm'>14 July, 2021</h1>
                                <h1 className='text-2xl mb-3'>JavaScript String Methods</h1>
                                <p className='font-thin'>We will discuss the JavaScript string method. I didn’t use string methods very much in my career. But as a JavaScript programmer, it’s good to know you.</p>
                                <small>3 min read...</small><br />
                                <a target='_blank' rel="noreferrer" href="https://mdtajuuddintarek.medium.com/javascript-string-methods-19eff1e7d5f3"><Tooltip TransitionComponent={Zoom} title="To Medium.com" placement="top" arrow><Button className='blogs_btn'>View</Button></Tooltip></a>
                            </div>
                        </li>
                        <li>
                            <div className="timeline_content">
                                <h1 className='blog_date text-sm'>12 July, 2021</h1>
                                <h1 className='text-2xl mb-3'>Form input tags in React</h1>
                                <p className='font-thin'>I gonna show you how to get data from input tags in React with professional way.</p>
                                <small>2 min read...</small><br />
                                <a target='_blank' rel="noreferrer" href="https://mdtajuuddintarek.medium.com/a-professional-way-to-getting-data-from-input-tags-in-react-ad0d2b3fefa6"><Tooltip TransitionComponent={Zoom} title="To Medium.com" placement="top" arrow><Button className='blogs_btn'>View</Button></Tooltip></a>
                            </div>
                        </li>
                        <li>
                            <div className="timeline_content">
                                <h1 className='blog_date text-sm'>11 July, 2021</h1>
                                <h1 className='text-2xl mb-3'>Material-Ui default color</h1>
                                <p className='font-thin'>Material-Ui default color is blue. I will show you how to change the default color in two steps.</p>
                                <small>2 min read...</small><br />
                                <a target='_blank' rel="noreferrer" href="https://mdtajuuddintarek.medium.com/the-complete-solution-to-change-the-material-ui-default-color-7c20b3a155fc"><Tooltip TransitionComponent={Zoom} title="To Medium.com" placement="top" arrow><Button className='blogs_btn'>View</Button></Tooltip></a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default Blogs;